import ujs from '@rails/ujs';
ujs.start();

import customizeColors from '@upstream/cobot_assets/src/customize-colors';
customizeColors({});
